import React from "react";
import { useLocation } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/14454552683?text=" + encodeURIComponent("Hi Janté, I'd like help planning a trip.");
const HIDE_ON = [/^\/admin(\/|$)/i, /^\/concierge(\/|$)/i];

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  if (HIDE_ON.some((re) => re.test(pathname))) return null;
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Janté on WhatsApp"
      data-testid="whatsapp-chat-button"
      className="fixed bottom-40 right-6 sm:bottom-24 z-40 w-12 h-12 rounded-full bg-[#25D366] text-white shadow-xl flex items-center justify-center hover:scale-110 transition-transform group"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor" aria-hidden="true">
        <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.44-9.43 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.67c0 5.2-4.24 9.43-9.44 9.43zm8.03-17.46A11.29 11.29 0 0 0 12.04.71C5.78.71.69 5.8.69 12.06c0 2 .52 3.95 1.52 5.67L.6 23.29l5.69-1.49a11.33 11.33 0 0 0 5.75 1.47h.01c6.26 0 11.35-5.09 11.35-11.35 0-3.03-1.18-5.88-3.32-8.02z" />
      </svg>
      <span className="absolute right-full mr-3 whitespace-nowrap bg-[var(--emerald)] text-[var(--ivory)] text-[11px] uppercase tracking-[0.18em] px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none rounded">
        WhatsApp us
      </span>
    </a>
  );
};

export default WhatsAppButton;
